import React, { useEffect, useState } from 'react'
import { CSSForMultiSelectOptionNew, CSSForSelect15vWWidth, CSSForSelectModern, CSSForSelectModern15VWWidth, handleErrorToast, ProgressModal } from '../CustomFunctions';
import { BASE_URL } from '../../config/axios';
import axios from 'axios';
import { AddwithWhiteCircle } from '../AllSvg';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast, ToastContainer } from 'react-toastify';
import "./employeeBulk.css";
import { LucideFile, X } from 'lucide-react';

const EmployeeBOQinBulk = ({ id, getBreakdowncost, logData, breakDownList, breakDownSubProfessional, breakDownSupport }) => {
    const [show, setShow] = useState(false);
    const [designationCache, setDesignationCache] = useState({});
    const [errors, setErrors] = useState({});

    const [formData, setFormData] = useState([{
        rate: "",
        rank: "",
        MM_construction_period: "",
        MM_OM_period: "",
        project: id,
        professional_type: null,
        designation: "",
        random_value_of_changes: "",
        reason_of_change: "",
        empcode: [],
        eot_details: [],
        total_amount: 0,
        total_month: 0,

    }]);

    // Update your ebBulkSelectStyles to include menuPortal
    const ebBulkSelectStyles = {
        control: (base, state) => ({
            ...base,
            border: '2px solid #e2e8f0',
            borderRadius: '8px',
            minHeight: '38px',
            boxShadow: state.isFocused ? '0 0 0 3px rgba(66, 153, 225, 0.15)' : 'none',
            '&:hover': {
                borderColor: '#a0aec0'
            },
            fontSize: '13px',
            width: '100%',
            minWidth: '140px',
        }),
        placeholder: (base) => ({
            ...base,
            color: '#a0aec0',
            fontSize: '12px'
        }),
        singleValue: (base) => ({
            ...base,
            color: '#2d3748',
            fontWeight: '500'
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: '#4a5568',
            padding: '4px 6px',
            '&:hover': {
                color: '#4299e1'
            }
        }),
        menu: (base) => ({
            ...base,
            borderRadius: '8px',
            boxShadow: '0 10px 40px rgba(0,0,0,0.12)',
            marginTop: '4px',
            border: '1px solid #e2e8f0',
            zIndex: 9999,
        }),
        menuList: (base) => ({
            ...base,
            padding: '4px',
            maxHeight: '200px',
        }),
        option: (base, { isFocused, isSelected }) => ({
            ...base,
            backgroundColor: isSelected ? '#4299e1' : isFocused ? '#ebf8ff' : 'white',
            color: isSelected ? 'white' : '#2d3748',
            padding: '8px 12px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '13px',
            '&:active': {
                backgroundColor: '#3182ce'
            }
        }),
        // Add portal styles
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    };

    const ebBulkMultiSelectStyles = {
        ...ebBulkSelectStyles,
        control: (base, state) => ({
            ...ebBulkSelectStyles.control(base, state),
            minHeight: '42px',
            minWidth: '160px',
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: '#ebf8ff',
            borderRadius: '6px',
            padding: '2px 6px',
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: '#2b6cb0',
            fontWeight: '500',
            fontSize: '12px',
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: '#2b6cb0',
            '&:hover': {
                backgroundColor: '#fc8181',
                color: 'white',
                borderRadius: '4px',
            }
        }),
    };

    const [eotObjects, setEotObjects] = useState([]);
    const [projectData, setProjectData] = useState({});

    const getProjectByid = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/project/${id}/`);
            setProjectData(res.data);
        } catch (error) {
            handleErrorToast(error);
        }
    }


    useEffect(() => {
        getProjectByid();
    }, [id])

    const company_id = projectData?.sub_company

    const division_id = company_id === "a2b6154c-5c4a-4bcb-a4ec-b151c5c652b5" ? "59408e4e-a455-46b6-b3db-8deaa0ae4475" : "0b6fa5d0-6de9-459b-b2c5-4a799c309713"

    useEffect(() => {
        if (Array.isArray(breakDownList) && breakDownList.length > 0) {

            const eotLength = breakDownList[0]?.eot_details?.length || 0;

            if (eotLength > 0) {

                const newEots = Array.from({ length: eotLength }, () => ({
                    rate: 0,
                    cp: 0,
                    dlp: 0,
                    t_month: 0,
                    boqId: breakDownList[0].id,
                    total_amount: 0,
                }));

                setEotObjects(newEots);

                setFormData((prev) =>
                    prev.map((item) => ({
                        ...item,
                        eot_details: newEots
                    }))
                );
            }
        }
    }, [breakDownList]);

    useEffect(() => {
        if (!Array.isArray(breakDownList) || breakDownList.length === 0) return;

        const anyReasonFilled = breakDownList.some(
            (item) =>
                item.reason_of_change !== "null" &&
                item.reason_of_change !== null &&
                item.reason_of_change !== ""
        );

        let selectedData = null;

        if (anyReasonFilled) {
            selectedData = [...breakDownList]
                .filter(
                    (item) =>
                        item.random_value_of_changes &&
                        !isNaN(new Date(item.random_value_of_changes))
                )
                .sort(
                    (a, b) =>
                        new Date(b.random_value_of_changes) -
                        new Date(a.random_value_of_changes)
                )[0];
        } else {
            selectedData = breakDownList.find(
                (item) =>
                    item.random_value_of_changes &&
                    (item.reason_of_change === "null" ||
                        item.reason_of_change === null ||
                        item.reason_of_change === "")
            );
        }

        if (selectedData?.random_value_of_changes) {
            setFormData((prev) =>
                prev.map((item) => ({
                    ...item,
                    random_value_of_changes: selectedData.random_value_of_changes,
                    reason_of_change: selectedData.reason_of_change || "",
                }))
            );
        }
    }, [breakDownList]);

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;

        setFormData((prev) => {
            const updated = [...prev];

            updated[index] = {
                ...updated[index],
                [name]: name === "rank" && value === "" ? index + 1 : value
            };

            return updated;
        });

        // call API only if professional_type changes
        if (name === "professional_type") {
            getDesignation(value, index);
        }
    };

    useEffect(() => {
        setFormData((prev) =>
            prev.map((item, index) => ({
                ...item,
                rank: item.rank || index + 1   // only set if empty
            }))
        );
    }, [formData.length]);
    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
        setFormData([{
            rate: "",
            MM_construction_period: "",
            MM_OM_period: "",
            project: id,
            professional_type: null,
            designation: "",
            random_value_of_changes: "",
            reason_of_change: "",
            empcode: [],
            eot_details: [],
            total_amount: 0,
            total_month: 0,
            rank: "",
        }])
    }


    const [loading, setLoading] = useState(false); //loading logic
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const [employeeList, setEmployeeList] = useState([]);
    const [buffer, setBuffering] = useState(true);

    const [designation, setDesignation] = useState({});
    const getEmployee = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const [pro, multiple] = await Promise.all([
                axios.get(`${BASE_URL}/siteproject/employeeboqbyproject/${id}/null/`),
                axios.get(`${BASE_URL}/siteproject/employeemultipleproject/${id}/`)
            ]);

            const merged = [...pro.data, ...multiple.data];
            const uniqueByIdMap = new Map();
            merged.forEach((emp) => {
                uniqueByIdMap.set(emp.id, emp);
            });
            const uniqueEmployeeList = Array.from(uniqueByIdMap.values());

            setEmployeeList(uniqueEmployeeList);
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        if (show === true) {
            getEmployee();
        }
    }, [show]);


    const getDesignation = async (professionalType, index) => {
        if (!professionalType) return;

        // ✅ If already cached, use it
        if (designationCache[professionalType]) {
            setDesignation((prev) => ({
                ...prev,
                [index]: designationCache[professionalType]
            }));
            return;
        }

        setBuffering(true);

        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/designationfilter/${division_id}/null/null/${professionalType}/`
            );

            // store in cache
            setDesignationCache((prev) => ({
                ...prev,
                [professionalType]: res.data
            }));

            // store for row
            setDesignation((prev) => ({
                ...prev,
                [index]: res.data
            }));

        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    const ProfessionalTypeList = [
        { value: "Key Professional", label: "Key Professional" },
        { value: "Sub Professional", label: "Sub Professional" },
        { value: "Support Staff", label: "Support Staff" }
    ]

    const ProfessionalTypeOptions = ProfessionalTypeList.map((i) => ({
        value: i.value,
        label: i.label

    }))

    const handleProfessionalTypeChange = (selectedOption, index) => {
        const value = selectedOption ? selectedOption.value : null;
        setFormData((prev) => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                professional_type: value,
                designation: "",
                empcode: [],
            };
            return updated;
        });
        getDesignation(value, index);
    };

    const designationOptions = designation[0]?.map((item) => ({
        value: item.id,
        label: item.title
    })) || [];

    const handleDesignationChange = (selectedOption, index) => {
        const value = selectedOption ? selectedOption.value : "";
        setFormData((prev) => {

            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                designation: value,
                empcode: [],
            };
            return updated;
        });
    };
    const getEmployeeOptions = (designation) => [
        {
            value: 'create-new-employee',
            label: 'Create New Employee',
        },
        ...(designation
            ? employeeList
                .filter((employee) => employee.designation === designation)
                .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code) || a.emp_code.localeCompare(b.emp_code))
                .map((e) => ({
                    value: e.id,
                    label: `${e.emp_code} - ${e.name}`,
                }))
            : []),


    ];
    const [showCreateEmployeeModal, setShowCreateEmployeeModal] = useState(false);

    const handleChangecc = (index, selected) => {
        const empcode = Array.isArray(selected) && selected.length > 0
            ? selected.map((item) => item.value)
            : [];

        if (empcode.includes('create-new-employee')) {
            setShowCreateEmployeeModal(true);
        } else {
            setFormData((prevState) =>
                prevState.map((item, i) =>
                    i === index
                        ? { ...item, empcode }
                        : item
                )
            );
        }

    };

    const getSelectedEmployees = (entry) => {
        if (!entry) return [];

        const empcode = entry.empcode || [];

        // Get the current list of employees matching this designation
        const options = getEmployeeOptions(entry.designation);

        if (Array.isArray(empcode) && empcode.length > 0) {
            return empcode
                .map((empId) => options.find((option) => option.value === empId))
                .filter(Boolean); // Only return found ones
        }



        const fallback = entry?.person_using_conveyance;
        const fallbackOption = options.find((option) => option.value === fallback);
        return fallbackOption ? [fallbackOption] : [];
    };

    console.log(designation, "designation");

    const handleAddRow = () => {
        setFormData((prev) => [
            ...prev,
            {
                rate: "",
                MM_construction_period: "",
                MM_OM_period: "",
                project: id,
                professional_type: null,
                designation: "",
                random_value_of_changes: "",
                reason_of_change: "",
                empcode: [],
                eot_details: eotObjects.length > 0 ? eotObjects : [],

                total_amount: 0,
                total_month: 0,
                rank: "",
            }
        ]);
    };


    const handleRemoveRow = (index) => {
        setFormData((prev) => {
            if (prev.length === 1) return prev; // prevent removing last row

            const updated = [...prev];
            updated.splice(index, 1);

            return updated.map((item, i) => ({
                ...item,
                rank: item.rank || i + 1   // keep manual rank, only auto if empty
            }));
        });
    };

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["rank", "MM_OM_period", "MM_construction_period", "professional_type", "designation", "rate"];

        formData.forEach((item, index) => {
            requiredFields.forEach((field) => {
                if (!item[field]) {
                    newErrors[`${index}_${field}`] =
                        `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
                }
            });
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            setShowProgressModal(true);
            setUploadProgress(0); // Reset progress
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(
                    `${BASE_URL}/siteproject/bulkboqemployeepost/`,
                    formData,
                    {
                        onUploadProgress: (progressEvent) => {
                            const percentCompleted = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            setUploadProgress(percentCompleted);
                        },
                    }
                );

                if (res.status === 201) {
                    await getBreakdowncost();

                    handleClose();
                    setTimeout(() => {
                        toast.dismiss(loadingToastId); // Close loading toast
                        toast.success("BOQ Added Successfully"); // Show success toast
                    }, 4000);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err, loadingToastId);
            } finally {

                setTimeout(() => {
                    setShowProgressModal(false);
                }, 2000); // Hide after 3 seconds

                setTimeout(() => {
                    setLoading(false); //loading logic
                    toast.dismiss(loadingToastId);
                }, 4000)

            }
        }
    };


    return (
        // <>
        //     <button title="Update employee BOQ" className="upload-svg flex-row" onClick={handleShow}>

        //         <AddwithWhiteCircle /> Employee BOQ
        //     </button>
        //     {
        //         showProgressModal ?
        //             <ProgressModal show={showProgressModal} progress={uploadProgress} /> :
        //             <Modal
        //                 show={show}
        //                 onHide={handleClose}
        //                 dialogClassName="width-90vw-Modal"
        //             >
        //                 <Modal.Header closeButton >
        //                     <Modal.Title>Add Employeee Data for BOQ</Modal.Title>

        //                 </Modal.Header>


        //                 <Modal.Body>
        //                     <div className="parent-div">
        //                         <div className="bdy-div">
        //                             <div className='addrowcss'>
        //                                 <button className="upload-svg" onClick={handleAddRow}>
        //                                     <AddwithWhiteCircle /> Add Row
        //                                 </button>
        //                             </div>

        //                             <div className='table-box scroll-container-table'>

        //                                 <table className="nested-table-lightblue width-90vw payment">
        //                                     <thead className="table-heading" style={{ zIndex: "999" }}>
        //                                         <tr className="custom-table-head-tr width-10vw">
        //                                             <th className="table-heading-text text-left-sr" >Rank</th>
        //                                             <th className="table-heading-text text-center">Professional Type <br /> <span className="required">*</span></th>
        //                                             <th className="table-heading-text text-center">Designatons <br /> <span className="required">*</span></th>
        //                                             <th className="table-heading-text text-center">Employee Name</th>
        //                                             <th className="table-heading-text text-center">MM Construction Period <br /><span className="required">*(In-Months)</span></th>
        //                                             <th className="table-heading-text text-center">MM O&M Period <br /><span className="required">*(In-Months)</span></th>
        //                                             <th className="table-heading-text text-center">Total MM <br /> <span className="required">(Read-Only)</span></th>

        //                                             <th className="table-heading-text text-center">Rate  <br /> <span className="required">*(Monthly-Rate)</span></th>
        //                                         </tr>
        //                                     </thead>


        //                                     <tbody>

        //                                         {formData.map((entry, index) => (
        //                                             <tr key={index} className="custom-table-head-td ">

        //                                                 <td className="align-left width-5vw" >
        //                                                     {formData.length !== 1 &&
        //                                                         <button
        //                                                             type="button"
        //                                                             className='removebuttoncss'
        //                                                             disabled={formData.length === 1}
        //                                                             onClick={() => handleRemoveRow(index)}
        //                                                         >
        //                                                             X
        //                                                         </button>
        //                                                     }
        //                                                     <input
        //                                                         name="rank"
        //                                                         value={entry.rank}
        //                                                         onChange={(e) => handleInputChange(e, index)}
        //                                                         className={`form-input-date width-5vw ${errors[`${index}_rank`] ? "error" : ""}`}
        //                                                         type="text"
        //                                                     />
        //                                                 </td>
        //                                                 <td className=''>

        //                                                     <div title="Professional Type" className="flex-column align-items-center">
        //                                                         <Select
        //                                                             options={ProfessionalTypeOptions}
        //                                                             onChange={(selected) => handleProfessionalTypeChange(selected, index)}
        //                                                             // isMulti
        //                                                             value={ProfessionalTypeOptions.find((option) => option.value === entry.professional_type) || null}
        //                                                             styles={CSSForSelect15vWWidth}
        //                                                         />
        //                                                         {errors[`${index}_professional_type`] && (
        //                                                             <span className="error-message font-size-text ">{errors[`${index}_professional_type`]}</span>
        //                                                         )}

        //                                                     </div>



        //                                                 </td>
        //                                                 <td>
        //                                                     <div title="Designation" className="flex-column align-items-center">
        //                                                         <Select
        //                                                             options={
        //                                                                 designation[index]?.map((item) => ({
        //                                                                     value: item.id,
        //                                                                     label: item.title
        //                                                                 })) || []
        //                                                             }
        //                                                             onChange={(selected) => handleDesignationChange(selected, index)}
        //                                                             // isMulti
        //                                                             value={
        //                                                                 designation[index]
        //                                                                     ?.map((item) => ({
        //                                                                         value: item.id,
        //                                                                         label: item.title
        //                                                                     }))
        //                                                                     .find((option) => option.value === entry.designation) || null
        //                                                             } styles={CSSForSelect15vWWidth}
        //                                                         />
        //                                                         {errors[`${index}_designation`] && (
        //                                                             <span className="error-message font-size-text ">{errors[`${index}_designation`]}</span>
        //                                                         )}

        //                                                     </div>
        //                                                 </td>

        //                                                 <td>
        //                                                     <div title="EmployeeName" className="flex-column align-items-center">
        //                                                         <Select
        //                                                             options={getEmployeeOptions(entry.designation)}
        //                                                             onChange={(selected) => handleChangecc(index, selected)}
        //                                                             // placeholder={entry.employee_name_details.length > 0 ? entry.employee_name_details[0]?.name : "Select Employee"}
        //                                                             isMulti
        //                                                             value={getSelectedEmployees(entry)}
        //                                                             styles={{
        //                                                                 control: (provided) => ({
        //                                                                     ...provided,
        //                                                                     width: '15vw',
        //                                                                     minHeight: '50px',
        //                                                                     borderRadius: '10px',
        //                                                                     border: '1px solid #e3e3e3',
        //                                                                     margin: '10px 0px 20px 0px',
        //                                                                     color: '#4a4a4a',
        //                                                                     backgroundColor: '#f7f8fa',
        //                                                                     padding: '0px 10px',
        //                                                                 }),
        //                                                                 placeholder: (provided) => ({
        //                                                                     ...provided,
        //                                                                     color: '#4a4a4a',
        //                                                                 }),
        //                                                                 menu: (provided) => ({
        //                                                                     ...provided,
        //                                                                     width: '10vw',
        //                                                                     borderRadius: '10px',
        //                                                                     marginTop: '0',
        //                                                                 }),
        //                                                                 singleValue: (provided) => ({
        //                                                                     ...provided,
        //                                                                     color: '#4a4a4a',
        //                                                                 }),
        //                                                                 input: (provided) => ({
        //                                                                     ...provided,
        //                                                                     color: '#4a4a4a',
        //                                                                 }),
        //                                                             }}
        //                                                         />
        //                                                         {errors.remarks && (
        //                                                             <span className="error-message font-size-text ">{errors.remarks}</span>
        //                                                         )}
        //                                                         <div>
        //                                                             {errors[`${index}_actual_month`] && (
        //                                                                 <span className="error-message font-size-text ">{errors[`${index}_actual_month`]}</span>
        //                                                             )}
        //                                                         </div>
        //                                                     </div>
        //                                                 </td>
        //                                                 <td>
        //                                                     <div title="MM const. Period" className="flex-column align-items-center">
        //                                                         <input
        //                                                             className={`form-input-date  width-5vw  ${errors[`${index}_MM_construction_period`] ? "error" : ""}`}
        //                                                             id={`MM_construction_period_${index}`}
        //                                                             name="MM_construction_period"
        //                                                             type="number"
        //                                                             value={entry.MM_construction_period}
        //                                                             onChange={(e) => handleInputChange(e, index)}

        //                                                         />
        //                                                         <div>
        //                                                             {errors[`${index}_MM_construction_period`] && (
        //                                                                 <span className="error-message font-size-text ">{errors[`${index}_MM_construction_period`]}</span>
        //                                                             )}
        //                                                         </div>
        //                                                     </div>
        //                                                 </td>
        //                                                 <td>
        //                                                     <div title="MM O&M Period" className="flex-column align-items-center">
        //                                                         <input
        //                                                             className={`form-input-date  width-5vw  ${errors[`${index}_MM_OM_period`] ? "error" : ""}`}
        //                                                             id={`MM_OM_period_${index}`}
        //                                                             name="MM_OM_period"
        //                                                             type="text"
        //                                                             value={entry.MM_OM_period}
        //                                                             onChange={(e) => handleInputChange(e, index)}

        //                                                         />
        //                                                         <div>
        //                                                             {errors[`${index}_MM_OM_period`] && (
        //                                                                 <span className="error-message font-size-text ">{errors[`${index}_MM_OM_period`]}</span>
        //                                                             )}
        //                                                         </div>
        //                                                     </div>
        //                                                 </td>
        //                                                 <td>

        //                                                     <p className="text-center">
        //                                                         {Number(entry.MM_OM_period || 0) + Number(entry.MM_construction_period || 0)}
        //                                                     </p>
        //                                                 </td>
        //                                                 <td>
        //                                                     <div title="Monthly Rate" className="flex-column align-items-center">
        //                                                         <input
        //                                                             className={`form-input-date  width-5vw  ${errors[`${index}_rate`] ? "error" : ""}`}
        //                                                             id={`rate_${index}`}
        //                                                             name="rate"
        //                                                             type="text"
        //                                                             value={entry.rate}
        //                                                             onChange={(e) => handleInputChange(e, index)}

        //                                                         />
        //                                                         <div>
        //                                                             {errors[`${index}_rate`] && (
        //                                                                 <span className="error-message font-size-text ">{errors[`${index}_rate`]}</span>
        //                                                             )}
        //                                                         </div>
        //                                                     </div>
        //                                                 </td>


        //                                             </tr>
        //                                         ))}

        //                                     </tbody>

        //                                 </table>
        //                             </div>
        //                             <div className="button-models">
        //                                 <button
        //                                     className="model-button-cancel model-button font-weight500"
        //                                     onClick={handleClose}
        //                                 >
        //                                     Cancel
        //                                 </button>
        //                                 <button
        //                                     type="submit"
        //                                     className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
        //                                     disabled={loading}
        //                                     onClick={handleSubmit}
        //                                 >
        //                                     Submit
        //                                 </button>
        //                             </div>

        //                         </div>
        //                     </div>
        //                     <ToastContainer
        //                         position="top-center"
        //                         autoClose={1000}
        //                         hideProgressBar={false}
        //                         newestOnTop={true}
        //                         closeOnClick
        //                         rtl={false}
        //                         pauseOnFocusLoss
        //                         draggable
        //                         pauseOnHover
        //                     />

        //                 </Modal.Body >

        //             </Modal >
        //     }
        // </>

        <>
            <button
                title="Update employee BOQ"
                className="eb-bulk-trigger-btn"
                onClick={handleShow}
                style={{ background: "black" }}
            >
                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="16" />
                    <line x1="8" y1="12" x2="16" y2="12" />
                </svg>
                Employee BOQ
            </button>

            {showProgressModal ?
                <ProgressModal usedFor="Add" show={showProgressModal} progress={uploadProgress} /> :
                <Modal
                    show={show}

                    onHide={handleClose}
                    dialogClassName="eb-bulk-modal model-width90vw max-heightModal"
                >
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <LucideFile />
                            Add Employee Data for BOQ
                            <button className="close-btn" onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        <div className="eb-bulk-container">
                            <div className="eb-bulk-content">
                                <div className="eb-bulk-actions">
                                    <button className="eb-bulk-add-row-btn" onClick={handleAddRow}>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <circle cx="12" cy="12" r="10" />
                                            <line x1="12" y1="8" x2="12" y2="16" />
                                            <line x1="8" y1="12" x2="16" y2="12" />
                                        </svg>
                                        Add Row
                                    </button>
                                </div>

                                <div className="eb-bulk-table-wrapper">
                                    <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                                        <table className="eb-bulk-table">
                                            <thead className="eb-bulk-table-head">
                                                <tr className="eb-bulk-table-header-row">
                                                    <th className="eb-bulk-th eb-bulk-th-rank">
                                                        <span className="eb-bulk-th-label">Rank</span>
                                                    </th>
                                                    <th className="eb-bulk-th eb-bulk-th-professional">
                                                        <span className="eb-bulk-th-label">Professional Type</span>
                                                        <span className="eb-bulk-required">*</span>
                                                    </th>
                                                    <th className="eb-bulk-th eb-bulk-th-designation">
                                                        <span className="eb-bulk-th-label">Designations</span>
                                                        <span className="eb-bulk-required">*</span>
                                                    </th>
                                                    <th className="eb-bulk-th eb-bulk-th-employee">
                                                        <span className="eb-bulk-th-label">Employee Name</span>
                                                    </th>
                                                    <th className="eb-bulk-th eb-bulk-th-period">
                                                        <span className="eb-bulk-th-label">MM Construction Period</span>
                                                        <span className="eb-bulk-th-sub">(In-Months)</span>
                                                        <span className="eb-bulk-required">*</span>
                                                    </th>
                                                    <th className="eb-bulk-th eb-bulk-th-period">
                                                        <span className="eb-bulk-th-label">MM O&M Period</span>
                                                        <span className="eb-bulk-th-sub">(In-Months)</span>
                                                        <span className="eb-bulk-required">*</span>
                                                    </th>
                                                    <th className="eb-bulk-th eb-bulk-th-total">
                                                        <span className="eb-bulk-th-label">Total MM</span>
                                                        <span className="eb-bulk-th-sub">(Read-Only)</span>
                                                    </th>
                                                    <th className="eb-bulk-th eb-bulk-th-rate">
                                                        <span className="eb-bulk-th-label">Rate</span>
                                                        <span className="eb-bulk-th-sub">(Monthly-Rate)</span>
                                                        <span className="eb-bulk-required">*</span>
                                                    </th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {formData.map((entry, index) => (
                                                    <tr key={index} className="eb-bulk-row">
                                                        <td className="eb-bulk-td eb-bulk-td-rank">
                                                            <div className="eb-bulk-rank-container">
                                                                {formData.length !== 1 && (
                                                                    <button
                                                                        type="button"
                                                                        className="eb-bulk-remove-btn"
                                                                        disabled={formData.length === 1}
                                                                        onClick={() => handleRemoveRow(index)}
                                                                    >
                                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                            <line x1="18" y1="6" x2="6" y2="18" />
                                                                            <line x1="6" y1="6" x2="18" y2="18" />
                                                                        </svg>
                                                                    </button>
                                                                )}
                                                                <input
                                                                    name="rank"
                                                                    value={entry.rank}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    className={`eb-bulk-input eb-bulk-input-rank ${errors[`${index}_rank`] ? "eb-bulk-input-error" : ""}`}
                                                                    type="text"
                                                                    placeholder="#"
                                                                />
                                                            </div>
                                                        </td>
                                                        <td className="eb-bulk-td">
                                                            <Select
                                                                options={ProfessionalTypeOptions}
                                                                onChange={(selected) => handleProfessionalTypeChange(selected, index)}
                                                                value={ProfessionalTypeOptions.find((option) => option.value === entry.professional_type) || null}
                                                                styles={CSSForSelectModern15VWWidth}
                                                                placeholder="Select Type"
                                                                isClearable
                                                            />
                                                            {errors[`${index}_professional_type`] && (
                                                                <span className="eb-bulk-error-text">{errors[`${index}_professional_type`]}</span>
                                                            )}
                                                        </td>
                                                        <td className="eb-bulk-td">
                                                            <Select
                                                                options={
                                                                    designation[index]?.map((item) => ({
                                                                        value: item.id,
                                                                        label: item.title
                                                                    })) || []
                                                                }
                                                                onChange={(selected) => handleDesignationChange(selected, index)}
                                                                isClearable
                                                                value={
                                                                    designation[index]
                                                                        ?.map((item) => ({
                                                                            value: item.id,
                                                                            label: item.title
                                                                        }))
                                                                        .find((option) => option.value === entry.designation) || null
                                                                }
                                                                styles={CSSForSelectModern}
                                                                placeholder="Select Designation"
                                                            />
                                                            {errors[`${index}_designation`] && (
                                                                <span className="eb-bulk-error-text">{errors[`${index}_designation`]}</span>
                                                            )}
                                                        </td>
                                                        <td className="eb-bulk-td">
                                                            <Select
                                                                options={getEmployeeOptions(entry.designation)}
                                                                onChange={(selected) => handleChangecc(index, selected)}
                                                                isMulti
                                                                value={getSelectedEmployees(entry)}
                                                                styles={CSSForSelectModern}
                                                                placeholder="Select Employees"
                                                            />
                                                        </td>
                                                        <td className="eb-bulk-td">
                                                            <div className="eb-bulk-input-wrapper">
                                                                <input
                                                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_MM_construction_period`] ? "eb-bulk-input-error" : ""}`}
                                                                    id={`MM_construction_period_${index}`}
                                                                    name="MM_construction_period"
                                                                    type="number"
                                                                    value={entry.MM_construction_period}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    placeholder="0"
                                                                />
                                                                {errors[`${index}_MM_construction_period`] && (
                                                                    <span className="eb-bulk-error-text">{errors[`${index}_MM_construction_period`]}</span>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className="eb-bulk-td">
                                                            <div className="eb-bulk-input-wrapper">
                                                                <input
                                                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_MM_OM_period`] ? "eb-bulk-input-error" : ""}`}
                                                                    id={`MM_OM_period_${index}`}
                                                                    name="MM_OM_period"
                                                                    type="text"
                                                                    value={entry.MM_OM_period}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    placeholder="0"
                                                                />
                                                                {errors[`${index}_MM_OM_period`] && (
                                                                    <span className="eb-bulk-error-text">{errors[`${index}_MM_OM_period`]}</span>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className="eb-bulk-td eb-bulk-td-total">
                                                            <span className="eb-bulk-total-value">
                                                                {Number(entry.MM_OM_period || 0) + Number(entry.MM_construction_period || 0)}
                                                            </span>
                                                        </td>
                                                        <td className="eb-bulk-td">
                                                            <div className="eb-bulk-input-wrapper">
                                                                <input
                                                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_rate`] ? "eb-bulk-input-error" : ""}`}
                                                                    id={`rate_${index}`}
                                                                    name="rate"
                                                                    type="text"
                                                                    value={entry.rate}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    placeholder="₹ 0.00"
                                                                />
                                                                {errors[`${index}_rate`] && (
                                                                    <span className="eb-bulk-error-text">{errors[`${index}_rate`]}</span>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="eb-bulk-footer-actions">
                                    <button
                                        className="eb-bulk-btn eb-bulk-btn-cancel"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="eb-bulk-btn eb-bulk-btn-submit"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                        style={{ background: "black" }}
                                    >
                                        {loading ? (
                                            <span className="eb-bulk-btn-loader">
                                                <span className="eb-bulk-spinner"></span>
                                                Submitting...
                                            </span>
                                        ) : (
                                            <>
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                </svg>
                                                Submit
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            }
        </>
    )
}

export default EmployeeBOQinBulk